import { Injectable } from '@angular/core';
import { Survey } from '../models/survey.interface';
import { SurveyAnswer } from '../models/surveyanswer.interface';
import { ApiService } from './api/api.service';

@Injectable()
export class SurveyService {
    constructor(private apiService: ApiService) {}

    save(survey: Survey) {
        return this.apiService.postCall$<boolean>('surveys', survey);
    }

    submit(surveyId: number, answers: {}) {
        return this.apiService.postCall$<{ answers: {}; created_at: Date }>(`surveys/${surveyId}`, answers);
    }

    delete(surveyId: number) {
        return this.apiService.deleteCall$<boolean>(`surveys/${surveyId}`);
    }

    getAnswers(surveyId: number) {
        return this.apiService.getCallData$<SurveyAnswer[]>(`surveys/answers/${surveyId}`);
    }

    deleteAnswers(surveyId: number) {
        return this.apiService.deleteCall$<boolean>(`surveys/answers/${surveyId}`);
    }
}
